import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

import scrollbarStyle from 'Common/styles/scrollbar';

import { Cross } from '@solent-university/solent-icons';

export const Filters = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;

        @media ${theme.breakpoints.xlarge.media} {
            flex-wrap: nowrap;
        }
    `}
`;

export const SelectWrapper = styled.div<{ $type: string }>`
    ${({ theme, $type }) => css`
        margin-top: 1rem;
        min-width: 12rem;
        flex-grow: 1;

        @media ${theme.breakpoints.medium.media} {
            margin-top: 0;
        }

        @media ${theme.breakpoints.large.media} {
            min-width: 15rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            min-width: 12.5rem;
        }

        ${$type === 'courseCategories' &&
        css`
            min-width: 18rem;

            @media ${theme.breakpoints.medium.media} {
                max-width: 25rem;
            }

            @media ${theme.breakpoints.large.media} {
                min-width: 19rem;
            }

            @media ${theme.breakpoints.xlarge.media} {
                min-width: 16.5rem;
                max-width: none;
            }
        `}
    `}
`;

export const ToggleWrapper = styled.div`
    ${({ theme }) => css`
        margin-top: 1rem;

        @media ${theme.breakpoints.medium.media} {
            margin-top: 0;
        }
    `}
`;

export const SearchWrapper = styled.div`
    ${({ theme }) => css`
        @media ${theme.breakpoints.medium.media} {
            width: 20rem;
        }
    `}
`;

export const InfoWrapper = styled.div`
    ${({ theme }) => css`
        margin: 1.5rem 0;

        @media ${theme.breakpoints.large.media} {
            display: flex;
            justify-content: space-between;
            margin: 3rem 0 1.5rem;
        }
    `}
`;

export const PillWrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;

        @media ${theme.breakpoints.medium.media} {
            min-height: 2.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            gap: 1rem;
        }
    `}
`;

export const ModalPillWrapper = styled(PillWrapper)`
    ${({ theme }) => css`
        margin-top: 1rem;
        max-height: 6.75rem;
        overflow-y: auto;
        ${scrollbarStyle()}

        ::-webkit-scrollbar-track {
            background: ${theme.colors.background.hex};
        }

        ::-webkit-scrollbar-thumb {
            background: ${theme.colors.secondary.tints[5].hex};
        }
    `}
`;

export const FilterPillButton = styled.button`
    ${({ theme }) => css`
        border-radius: 1.5rem;
        border: none;
        background: ${theme.colors.primaryContrast.hex};
        padding: 0.5rem 0.75rem;
        font-size: 1rem;
        cursor: pointer;
    `}
`;

export const StyledIcon = styled(Cross)`
    width: 0.5rem;
    margin: 0 0 0.05rem 0.5rem;
`;

export const ResultsText = styled.p`
    ${({ theme }) => css`
        font-size: 1rem;
        font-weight: 300;

        @media ${theme.breakpoints.medium.media} {
            text-align: right;
        }

        @media ${theme.breakpoints.large.media} {
            text-align: unset;
            font-size: 1.125rem;
            margin: 0 0 0 3rem;
            padding-top: 0.25rem;
            white-space: nowrap;
        }
    `}
`;

export const ResultsNumber = styled.span`
    ${({ theme }) => css`
        color: ${theme.colors.primary.hex};
        font-weight: 600;
    `}
`;

export const Icon = styled.svg`
    width: 1rem;
    margin-right: 0.5rem;
`;

export const FilterButton = styled.button`
    ${({ theme }) => css`
        margin-top: 1rem;
        width: 100%;
        padding: 0.75rem;
        border-radius: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        background: ${theme.colors.tertiary.hex};
        color: ${theme.colors.primaryContrast.hex};
        cursor: pointer;
    `}
`;

export const MobileMenu = styled.div`
    ${({ theme }) => css`
        position: relative;
        z-index: 2;
        background-color: ${theme.colors.secondary.tints[1].hex};
        height: 100%;
        width: 100%;
    `}
`;

export const Modal = styled(animated.div)`
    position: fixed;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    z-index: 100000;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 1.5rem;
    width: 1.25rem;
    height: 1.25rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;

    ${Icon} {
        width: 1.25rem;
        margin: 0;
    }
`;

export const StyledHr = styled.hr`
    ${({ theme }) => css`
        color: ${theme.colors.secondary.tints[2].hex};
        margin: 2rem 0 0;
    `}
`;

export const MobileButtonWrapper = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;

    ${FilterButton} {
        border-radius: 0;
        padding: 1.75rem 0.75rem;
        margin-top: 2rem;
    }
`;

export const HeadingWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        background: ${theme.colors.primaryContrast.hex};
        padding: 1.5rem;
    `}
`;

export const Heading = styled.h2`
    font-weight: 300;
    font-size: 1.5rem;
    margin: 0;
    line-height: 1;
    text-align: center;
`;
